import devProxyApiUrl from '~/utils/devProxyApiUrl';

function buildUrl(isMcom) {
  if (isMcom) {
    return '/xapi/loyalty/v1/starrewardssummary?_origin=HnF';
  }
  return '/xapi/loyalty/v1/accountsummary?_origin=HnF';
}

export async function useLoyaltyPointsFetch({ isSignedIn, uid, guid, isMcom, killswitches, hostlink }) {
  const proxy = devProxyApiUrl(hostlink);
  const headers = {
    'x-macys-signedin': isSignedIn ? 1 : 0,
    'x-macys-uid': uid,
    'x-macys-userguid': guid,
    'x-requested-with': 'XMLHttpRequest',
  };

  const url = proxy(buildUrl(isMcom));

  if (killswitches?.persistentLoginEnabled) {
    const { PersistentLoginUtil } = await import('@nuxt-common/util/app/utils/persistentLogin');
    Object.assign(headers, PersistentLoginUtil.getDeviceFingerPrintHeaders());
  }

  return $fetch(url, { headers });
}
